import React from 'react';
import { Link } from 'react-router-dom';
import LogisticsPageHero from '../Logistics/LogisticsPageHero';

const ReturnHero: React.FC = () => {
  return (
    <LogisticsPageHero
      ariaLabel="Returns handling UK"
      imageSrc="/Images/return-handling.webp"
      imageAlt="Returns handling warehouse"
      titleLight="Returns Management UK"
      titleAccent="Fast, Accurate & Hassle-Free Return Handling Services"
      description={
        <>
          <p>
            Our return handling services simplify reverse logistics for ecommerce brands across the UK. We
            inspect, process, restock, or dispose of returned products quickly — whether stock comes from{' '}
            <Link to="/shopify-fulfillment-services">Shopify orders</Link>,{' '}
            <Link to="/multi-channel-fulfillment-services">multi-channel fulfilment</Link>, or{' '}
            <Link to="/blog/how-to-handle-amazon-removal-orders-uk">Amazon FBA removal orders</Link> — helping
            reduce costs, recover inventory value, and streamline returns management. If stock is stuck unsellable
            in FBA, see how to{' '}
            <Link to="/blog/fix-stranded-inventory-amazon-uk-seller-guide-2026">
              fix Amazon stranded inventory
            </Link>
            .
          </p>
        </>
      }
      primaryCta={{ label: 'Become A Client', to: '/contact-fulfillment-services' }}
    />
  );
};

export default ReturnHero;
